module.exports = __webpack_public_path__ + "img/content1.2595eefd.png";